module.exports = __webpack_public_path__ + "media/images/valentin_rosen_dunkelrot-a071f3d2c774da209ff9a3c56b5aa219.jpeg";